export default __webpack_public_path__ + "static/indoor10-4c0573e5a73af4127e34684ed8f91648.webp";